import { render, staticRenderFns } from "./MagazineModal.vue?vue&type=template&id=f2d1a404&"
import script from "./MagazineModal.vue?vue&type=script&lang=js&"
export * from "./MagazineModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports